import axios from 'axios';

const baseURL = `${process.env.REACT_APP_API_URL}`;

export const leadAPI = {
  add: async (info) => axios.post(`${baseURL}/add-lead`, info).then((res) => res.data),
  all: async () => axios.get(`${baseURL}/all-leads`).then((res) => res.data),
  single: async (idToSearch) => axios.get(`${baseURL}/manage-leads/${idToSearch}`).then((res) => res.data),
  update: async (idToSearch) => {
    const { id, ...details } = idToSearch;
    return axios.put(`${baseURL}/category/${id}`, details).then((res) => res.data);
  },
  delete: async (idToSearch) => axios.delete(`${baseURL}/manage-leads/${idToSearch}`).then((res) => res.data)
};
